import { gql } from '@apollo/client'

export const updateBrandingLabel = gql`
  mutation updateBrandingLabel(
    $id: Int!
    $labelKey: String!
    $labelValue: String!
    $languageCode: String!
    $brandingId: Float!
  ) {
    updateBrandingLabel(
      id: $id
      labelKey: $labelKey
      labelValue: $labelValue
      languageCode: $languageCode
      brandingId: $brandingId
    ) {
      id
      labelKey
      labelValue
      languageCode
      brandingId
    }
  }
`

export const updateBranding = gql`
  mutation updateBranding(
    $id: Int!
    $brandingKey: String
    $displayName: String
    $active: Boolean
    $logoBase64: String
    $faviconBase64: String
    $theme: JSONObject
  ) {
    updateBranding(
      id: $id
      brandingKey: $brandingKey
      displayName: $displayName
      active: $active
      logoBase64: $logoBase64
      faviconBase64: $faviconBase64
      theme: $theme
    ) {
      id
      brandingKey
      displayName
      active
      theme
      logo
      favicon
      createdAt
      updatedAt
    }
  }
`
